import { defineMessages } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'features.tenantSwitcher.label',
    defaultMessage: 'Tenant',
  },
  myTenant: {
    id: 'features.tenantSwitcher.myTenant',
    defaultMessage: 'My tenant',
  },
});

export default messages;
